import Timesheets from "../Pages/AttendenceManagement/Timesheets";
import CreateEmployeePage from "../v2/pages/onboard-pre-join/create-employee-page.tsx";
import ApproveBankDetailsPage from "../v2/pages/approve-bank-details/approve-bank-details-page.tsx";
import OnboardFormPage from "../v2/pages/onboard-form/onboard-form-page.tsx";
import HrSetupPage from "../v2/pages/hr-setup/hr-setup-page.tsx";
import ItApprovalPage from "../v2/pages/it-approval/it-approval-page.tsx";
import Performance from "../Pages/Employee/Performance";
import LeaveList from "../Pages/Leave/LeaveList";
import AssetList from "../Pages/AssetManagement/AssetList";
import Profile from "../Pages/Auth/Profile";
import AssignAsset from "../Pages/AssetManagement/AssignAsset";
import EmployeeProfile from "../Pages/EmployeeOnboard/EmployeeProfile";
import AssetDashboard from "../Pages/AssetManagement/AssetDashboard";
import PromoteEmployee from "../Pages/PromoteEmployee/PromoteEmployee";
import ProjectList from "../Pages/Project/ProjectList";
import MyProjects from "../Pages/Project/MyProjects";
import ProjectReport from "../Pages/Project/ProjectReport";
import EmployeeList from "../Pages/Employee/EmployeeList";
import TimeSheetView from "../Pages/AttendenceManagement/TimeSheetView";
import ApproveLeave from "../Pages/Leave/ApproveLeave";
import AssetRequest from "../Pages/AssetManagement/AssetRequest";
import UploadSalary from "../v2/pages/salarymanagement/upload-salary.tsx";
import Reimbursement from "../Pages/ExpenseManagement/Reimbursement";
import AssetRequestTabs from "../Pages/AssetManagement/AssetRequestTabs";
import ApproveAccessRequestDL from "../Pages/AssetLevelManagement/ApproveAccessRequestDL";
import ApproveAccessRequestIT from "../Pages/AssetLevelManagement/ApproveAccessRequestIT";
import ApproveAssetRequestList from "../Pages/AssetManagement/ApproveAssetRequestList";
import ApproveReimbursementList from "../Pages/ExpenseManagement/ApproveReimbursementList";
import ReimbursementRequestList from "../Pages/ExpenseManagement/ReimbursementRequestList";
import ModifyPolicy from "../Pages/PolicyManagement/ModifyPolicy";
import ViewPolicy from "../Pages/PolicyManagement/view-policy/ViewPolicy.jsx";
import UploadDocument from "../Pages/Employee/UploadDocument";
import LeaveUpdate from "../Pages/Leave/LeaveUpdate";
import FinalApproveLeave from "../Pages/Leave/FinalApproveLeave";
import DownloadReimbursement from "../Pages/ExpenseManagement/DownloadReimbursement";
import RoleList from "../Pages/Role/RoleList";
import MenuAssign from "../Pages/Menu/MenuAssign";
import PunchDetail from "../Pages/AttendenceManagement/PunchDetail";
import BulkPaid from "../Pages/ExpenseManagement/BulkPaid";
import EvaluationView from "../Pages/Employee/EvaluationView";
import RoleManagementPage from "../v2/pages/role-management/role-management-page.tsx";
import AppraisalUpload from "../Pages/AppraisalManagement/AppraisalUpload";
import ApproveDocument from "../Pages/Employee/ApproveDocument";
import RaiseEmailRequest from "../v2/pages/Adhoc_Module/raise-email-request-page.tsx";
import EmailCreationRequestApproval from "../v2/pages/Adhoc_Module/email-creation-request-approval-page.tsx";
import EmailRequestHrApprovalPage from "../v2/pages/Adhoc_Module/email-request-hr-approval-page.tsx";
import ApproveAssetRequestL1 from "../Pages/AssetLevelManagement/ApproveAssetRequestL1";
import ApproveAssetRequestL2 from "../Pages/AssetLevelManagement/ApproveAssetRequestL2";
import ApproveAssetRequestIT from "../Pages/AssetLevelManagement/ApproveAssetRequestIT";
import AssetDeliveryStore from "../Pages/AssetLevelManagement/AssetDeliveryStore";
import AssetRequestITApproverForm from "../Pages/AssetLevelManagement/AssetRequestITApproverForm";
import UsersRoleReport from "../Pages/ManagementReports/UsersRoleReport";
import AssetReport from "../Pages/ManagementReports/AssetReport";
import AssetReturnATO from "../Pages/AssetManagement/AssetReturnATO";
import AssetReturnedList from "../Pages/AssetManagement/AssetReturnedList";
import CreateAnnouncement from "../v2/pages/announcement-management/create-announcement-page.tsx";
import ViewAnnouncement from "../v2/pages/announcement-management/view-announcement-page.tsx";
import DepartmentList from "../Pages/Settings/DepartmentList";
import Designationlist from "../Pages/Settings/Designationlist";
import BiometricEmployeeProfile from "../Pages/Employee/Biometric/BiometricEmployeeProfile";
import EmployeeBiometricList from "../Pages/Employee/Biometric/EmployeeBiometricList";
import MyAttendance from "../Pages/AttendenceManagement/MyAttendance";
import ExportAttendance from "../Pages/AttendenceManagement/ExportAttendance";
import AssignMain from "../Pages/AssignManager/AssignMain";
import LeaveCreditRequest from "../Pages/AttendenceManagement/LeaveCreditRequest";
import ApproveLeaveCreditRequest from "../Pages/AttendenceManagement/ApproveLeaveCreditRequest";
import ReimbursementHistory from "../Pages/ExpenseManagement/ReimbursementHistory";
import HolidaysPage from "../v2/pages/holidays/holidays.tsx";
import HolidayManagement from "../Pages/AttendenceManagement/HolidayManagement";
import ApplyRegularization from "../Pages/AttendenceManagement/ApplyRegularization";
import ApproveRegularization from "../Pages/AttendenceManagement/ApproveRegularization";
import TeamRegularizations from "../Pages/AttendenceManagement/TeamRegularizations";
import EmployeeEvent from "../Pages/Employee/Event/EmployeeEvent";
import AssetTypeDetails from "../Pages/AssetManagement/AssetTypeDetails";
import OnOfficialDuty from "../Pages/Leave/OnOfficialDuty";
import ApproveOnOfficialDutyHR from "../Pages/Leave/ApproveOnOfficialDutyHR";
import ApproveOnOfficialDutyDL from "../Pages/Leave/ApproveOnOfficialDutyDL";
import EvaluateEmployeeV2 from "../Pages/Employee/EvaluateEmployeeV2";
import DownloadLeaveReport from "../Pages/Leave/DownloadLeaveReport";
import ProjectTabs from "../Pages/Project/ProjectTabs";
import ShadowResources from "../Pages/Project/ShadowResources/ShadowResources";
import CSATRating from "../Pages/Project/CSATRating/CSATRating";
import EmailDeletion from "../Pages/Employee/EmailDeletion";
import ApproveEmailDeletion from "../Pages/Employee/ApproveEmailDeletion";
import AddEmailDeletionRequest from "../Pages/Employee/AddEmailDeletionRequest";
import ITAssetAndAccessRequestsTabs from "../Pages/AssetManagement/ITAssetAndAccessRequestsTabs";

import ITAssetAndAccessDeallocationTabs from "../Pages/AssetManagement/ITAssetAndAccessDeallocationTabs";
import DownloadAccessReport from "../Pages/AssetLevelManagement/DownloadAccessReport";
// import FlowChart from "../components/FlowChart";
import NewAssetEnrollment from "../Pages/AssetManagement/NewAssetEnrollment";
import NewAccessEnrollment from "../Pages/AssetManagement/NewAccessEnrollment";
import CreateOffboardingRequest from "../Pages/EmployeeOffBoard/CreateOffboardingRequest";
import RaisedConcernRequests from "../Pages/RaiseConcerns/RaisedConcernRequests";
import MyConcerns from "../Pages/RaiseConcerns/MyConcerns";
import AppraisalReports from "../Pages/Appraisal/AppraisalReports";
import UploadAppraisal from "../Pages/Appraisal/UploadAppraisal";
import AssetMonitoringSystemTabs from "../Pages/AssetManagement/AssetMonitoringSystem/AssetMonitoringSysyemTabs";
import UploadSystemLogs from "../Pages/AssetManagement/UploadSystemLogs";
import ApproveWFHTimesheets from "../Pages/Timesheet/ApproveWFHTimesheets";
import ApprovalDashboardPage from "../v2/pages/approval-dashboard/approval-dashboard.tsx";
import OrganizationStructurePage from "../v2/pages/organization-structure/organization-structure-page.tsx";
import EmployeeProgressionPage from "../v2/pages/employee-progression/employee-progression-page.tsx";
import LeaveAttendanceManagementPage from "../v2/pages/leave-attendance-management/leave-attendance-management-page.tsx";
import WFHTimesheetHRRequests from "../Pages/Timesheet/WFHTimesheetHRRequests";
import MainDashboard from "../v2/components/features/dashboard/dashboard.tsx";
import TeamAvailabilityPage from "../v2/components/features/team-availability/team-availability-page.tsx";
import TrainingSessionsPage from "../v2/components/features/training-sessions/training-sessions-page.tsx";
import AdminProfile from "../Pages/Employee/AdminProfile.jsx";
import Timesheet from "../v2/pages/timesheet/timesheet.tsx";
import ExtensionReportPage from "../v2/pages/extension-report/extension-report.tsx";
import InsuranceTrackingPage from "../v2/pages/insurance-tracking/insurance-tracking-page.tsx";
import InsuranceBulkUploadPage from "../v2/pages/insurance-bulk-upload/insurance-bulk-upload-page.tsx";
import {
  GiveFeedbackPage,
  SelfCheckPage,
  MyFeedbackPage,
  PerformanceLensAdminPage,
  PerformanceConfigurationPage,
  PmDashboardPage,
  TeamSubmissionsPage,
  HodOverviewPage,
  MyPerformancePage,
  PerformanceDashboardPage,
} from "../v2/pages/performance-lens/performance-lens-page.tsx";
import TimeAllocationPage from "../v2/pages/time-allocation/time-allocation-page.tsx";
import TimeAllocatedOverview from "../v2/pages/time-allocated-overview/time-allocated-overview.tsx";
import ProjectReportsPage from "../v2/pages/project-reports/project-reports-page.tsx";
import OverviewTab from "../v2/components/features/timesheet/tabs/overview-tab/overview-tab.tsx";
import PendingApprovals from "../Pages/Timesheet/pending-approvals/pending-approvals.jsx";
import AssessmentPage from "../v2/pages/assessment/assessment-page.tsx";
import ProbationReviewPage from "../v2/pages/probation-review/probation-review-page.tsx";
import InitiateResignationPage from "../v2/pages/initiate-resignation/initiate-resignation-page.tsx";
import OffboardL1Page from "../v2/pages/offboard-l1/offboard-l1-page.tsx";
import OffboardL1DetailPage from "../v2/pages/offboard-l1/offboard-l1-detail-page.tsx";
import OffboardITPage from "../v2/pages/offboarding/offboard-it-page.tsx";
import OffboardITDetailPage from "../v2/pages/offboarding/offboard-it-detail-page.tsx";
import OffboardAdminPage from "../v2/pages/offboarding/offboard-admin-page.tsx";
import OffboardAdminDetailPage from "../v2/pages/offboarding/offboard-admin-detail-page.tsx";
import OffboardPayrollPage from "../v2/pages/offboarding/offboard-payroll-page.tsx";
import OffboardPayrollDetailPage from "../v2/pages/offboarding/offboard-payroll-detail-page.tsx";
import OffboardHRPage from "../v2/pages/offboarding/offboard-hr-page.tsx";
import OffboardHRDetailPage from "../v2/pages/offboarding/offboard-hr-detail-page.tsx";
import OffboardRMPage from "../v2/pages/offboarding/offboard-rm-page.tsx";
import OffboardRMDetailPage from "../v2/pages/offboarding/offboard-rm-detail-page.tsx";
import WorkStreamPage from "../v2/pages/work-stream/work-stream-page.tsx";
import WorkstreamConfigurationPage from "../v2/pages/workstream-configuration/workstream-configuration-page.tsx";
import GlobalDesignationPage from "../v2/pages/workstream-configuration/global-designation-page.tsx";
import WorkstreamTrackingPage from "../v2/pages/workstream-tracking/workstream-tracking-page.tsx";
import ProjectPhaseTimelinePage from "../v2/pages/workstream-tracking/project-phase-timeline-page.tsx";
import EmployeeViewDirectoryPage from "../v2/pages/employee-view-directory/employee-view-directory-page.tsx";
import EmployeeInformationDetailPage from "../v2/pages/employee-view-directory/employee-information-detail-page.tsx";
import UtilizationReportPage from "../v2/pages/utilization-report/utilization-report-page.tsx";
import TechStackListPage from "../v2/pages/tech-stack-list/tech-stack-list-page.tsx";
import EmployeeAppraisalPage from "../v2/pages/employee-appraisal/employee-appraisal-page.tsx";
import AppraisalApprovalPage from "../v2/pages/appraisal-approval/appraisal-approval-page.tsx";
import ApprovedAppraisalsPage from "../v2/pages/approved-appraisals/approved-appraisals-page.tsx";
import AppraisalManagementPage from "../v2/pages/appraisal-management/appraisal-management-page.tsx";
import ScheduleAppraisalPage from "../v2/pages/schedule-appraisal/schedule-appraisal-page.tsx";
import ProjectEnrollmentRequestsPage from "../v2/pages/project-enrollment-requests/project-enrollment-requests-page.tsx";
import GrowthActivitiesPage from "../v2/pages/growth-activities/growth-activities-page.tsx";
import { GrowthInsightsPage } from "../v2/pages/team-growth/team-growth-page.tsx";
// Prefix: /dashboard
export const dashboardRouteComponents = {
  "/": MainDashboard,
  "/team-availability": TeamAvailabilityPage,
  "/training-sessions": TrainingSessionsPage,
  "/myProfile": AdminProfile,
  "/performance": AssessmentPage,
  "/probationReview": ProbationReviewPage,
  // "/flowchart": FlowChart,
  // Employee management
  "/employee-directory": EmployeeList,
  "/yourColleague": EmployeeViewDirectoryPage,
  "/yourColleague/details": EmployeeInformationDetailPage,
  "/assignManager": AssignMain,
  "/promotionEmployee": PromoteEmployee,
  "/documentUpload": UploadDocument,
  "/employeeProgression": EmployeeProgressionPage,
  "/performanceEvaluation": EvaluateEmployeeV2,
  "/roleManagement": RoleManagementPage,
  "/approveDocument": ApproveDocument,
  "/approveBankDetails": ApproveBankDetailsPage,
  "/department": DepartmentList,
  "/organizationStructure": OrganizationStructurePage,
  "/designation": Designationlist,
  "/email-deletion": EmailDeletion,
  "/approve-email-deletion": ApproveEmailDeletion,
  "/appraisalReport": AppraisalReports,
  "/uploadappraisal": UploadAppraisal,
  "/appraisal": EmployeeAppraisalPage,
  "/appraisalapprove": AppraisalApprovalPage,
  "/approvedAppraisals": ApprovedAppraisalsPage,
  "/appraisalmanagement": AppraisalManagementPage,
  "/scheduleAppraisal": ScheduleAppraisalPage,

  // Asset management
  "/assetOverview": AssetDashboard,
  "/assetOverview/assetType/:id": AssetTypeDetails,
  "/assetAllocation": AssetList,
  "/assign-asset": AssignAsset,
  "/assetDeallocation": ITAssetAndAccessDeallocationTabs,
  // "/assetDeallocation": AssetDeallocation,
  // "/assetRequest": AssetRequestList,
  "/assetRequest": ITAssetAndAccessRequestsTabs,
  // "/createAssetRequest": AssetRequest,
  "/createAssetRequest": AssetRequestTabs,
  "/approve-access-request-dl": ApproveAccessRequestDL,
  "/approve-access-request-it": ApproveAccessRequestIT,
  // "/newAssetEnrollment": CreateAsset,
  "/newAssetEnrollment": NewAssetEnrollment,
  "/newAccessEnrollment": NewAccessEnrollment,
  "/approve-asset-request-l1": ApproveAssetRequestL1,
  "/approve-asset-request-l2": ApproveAssetRequestL2,
  "/approve-asset-request-it": ApproveAssetRequestIT,
  "/deliver-asset": AssetDeliveryStore,
  "/approve-asset-IT": AssetRequestITApproverForm,
  "/rto-managemrnt": AssetReturnATO,
  "/returned-asset": AssetReturnedList,
  "/accessReport": DownloadAccessReport,
  "/systemActivityReport": AssetMonitoringSystemTabs,
  "/uploadSystemLogs": UploadSystemLogs,

  // Attendance & leave management
  "/exPage": LeaveAttendanceManagementPage,
  "/punchDetail": PunchDetail,
  "/leaveApply": LeaveList,
  "/approveLeave": ApproveLeave,
  "/finalAproverLeave": FinalApproveLeave,
  "/myAttendance": MyAttendance,
  "/exportAttendance": ExportAttendance,
  "/requestLeaveCredits": LeaveCreditRequest,
  "/approveLeaveCredits": ApproveLeaveCreditRequest,
  "/holiday-management": HolidayManagement,
  "/holiday-list": HolidaysPage,
  "/on-leave-today": TeamAvailabilityPage,
  "/ood": OnOfficialDuty,
  "/ood-dl": ApproveOnOfficialDutyDL,
  "/ood-hr": ApproveOnOfficialDutyHR,
  "/applyRegularization": ApplyRegularization,
  "/my-team-regularization": TeamRegularizations,
  "/approve-regularization": ApproveRegularization,
  "/downloadLeaves": DownloadLeaveReport,
  "/raisedconcern": RaisedConcernRequests,
  "/myConcern": MyConcerns,
  "/overview": OverviewTab,
  "/timesheets": Timesheet,
  "/extensionReport": ExtensionReportPage,
  "/utilizationreport": UtilizationReportPage,
  "/techStackList": TechStackListPage,
  "/elevateYourself": GrowthActivitiesPage,
  "/reviewInitiatives": GrowthInsightsPage,
  "/approvetimesheets": ApproveWFHTimesheets,
  "/pending-approvals": PendingApprovals,

  // Project management
  "/projectList": ProjectList,
  // "/createProject": CreateProject,
  "/createProject": ProjectTabs,
  "/myProject": MyProjects,
  "/enrollmentrequests": ProjectEnrollmentRequestsPage,
  "/projectReport": ProjectReport,
  "/Reports": ProjectReportsPage,
  "/shadowResources": ShadowResources,
  "/csatRating": CSATRating,
  "/timeoverview": TimeAllocatedOverview,
  "/workStream": WorkStreamPage,
  "/configuration": WorkstreamConfigurationPage,
  "/configuration/global-designations": GlobalDesignationPage,
  "/tracking": WorkstreamTrackingPage,
  "/tracking/timeline/:projectId": ProjectPhaseTimelinePage,

  // Salary management
  "/uploadSalary": UploadSalary,
  "/emailDeletionRequest": AddEmailDeletionRequest,

  // Reimbursement management
  "/reimbursementRequest": ReimbursementRequestList,
  "/createReimbursementRequest": Reimbursement,
  "/approveReimbursements": ApproveReimbursementList,
  "/bulkReimbursement": BulkPaid,
  "/reimbursement-history": ReimbursementHistory,
  "/downloadReimbursement": DownloadReimbursement,

  // Policy management
  "/PolicyEditor": ModifyPolicy,
  "/policyViewer": ViewPolicy,

  // Role management
  "/roleList": RoleList,
  "/menuAssign": MenuAssign,

  // Appraisal management
  "/uploadAppraisal": AppraisalUpload,

  // Employee onboarding
  "/onboardingForm": OnboardFormPage,
  "/iTApproval": ItApprovalPage,
  "/hrSetup": HrSetupPage,
  "/create-employee": CreateEmployeePage,
  "/emailSetupRequest": RaiseEmailRequest,
  "/approveEmailSetup": EmailCreationRequestApproval,
  "/emailApproval": EmailRequestHrApprovalPage,
  "/biometirc-integration": EmployeeBiometricList,
  "/biometric-employee-profile": BiometricEmployeeProfile,

  // Management reports
  "/user-role-report": UsersRoleReport,
  "/asset-report": AssetReport,

  // Announcement management
  "/create-announcement": CreateAnnouncement,
  "/view-announcement": ViewAnnouncement,

  // Miscellaneous
  "/leave-list": LeaveUpdate,
  "/employee-event": EmployeeEvent,
  "/profile": Profile,
  "/evaluationView": EvaluationView,
  "/approveAssestRequest": ApproveAssetRequestList,
  "/employeeProfile": EmployeeProfile,
  "/timeSheet": Timesheets,
  "/timeSheetView": TimeSheetView,
  "/managementView": ApprovalDashboardPage,
  "/insauranceTracking": InsuranceTrackingPage,
  "/insuranceBulkUpload": InsuranceBulkUploadPage,
  "/giveFeedback": GiveFeedbackPage,
  "/selfCheck": SelfCheckPage,
  "/myFeedback": MyFeedbackPage,
  "/adminDashboard": PerformanceLensAdminPage,
  "/performanceConfiguration": PerformanceConfigurationPage,
  "/pmDashboard": PmDashboardPage,
  "/teamSubmissions": TeamSubmissionsPage,
  "/hodDashboard": HodOverviewPage,
  "/myPerformance": MyPerformancePage,
  "/performanceDashboard": PerformanceDashboardPage,
  "/timeSheetReqHr": WFHTimesheetHRRequests,
  "/timeAllocation": TimeAllocationPage,
  //Employee Offboarding

  "/createrequest": CreateOffboardingRequest,
  "/initiateresignation": InitiateResignationPage,
  "/offboardl1": OffboardL1Page,
  "/offboardl1/:offboardingId": OffboardL1DetailPage,
  "/offboardlIT": OffboardITPage,
  "/offboardlIT/:offboardingId": OffboardITDetailPage,
  "/offboardladmin": OffboardAdminPage,
  "/offboardladmin/:offboardingId": OffboardAdminDetailPage,
  "/offboardlpayroll": OffboardPayrollPage,
  "/offboardlpayroll/:offboardingId": OffboardPayrollDetailPage,
  "/offboardlhr": OffboardHRPage,
  "/offboardlhr/:offboardingId": OffboardHRDetailPage,
  "/offboardlrm": OffboardRMPage,
  "/offboardlrm/:offboardingId": OffboardRMDetailPage,
};

// These routes are not managed by the database
export const dbIndependentRoutes = [
  { path: "/myPerformance", title: "My Performance", description: "Give feedback, complete your self check, and view published results." },
  { path: "/performanceDashboard", title: "Performance Dashboard", description: "Manage the Performance Lens views available to your project role." },
  { path: "/performanceConfiguration", title: "Performance Configuration", description: "Manage Performance Lens cycles and questions." },
  { path: "/pmDashboard", title: "PM Dashboard", description: "Follow up on project feedback submissions." },
  { path: "/teamSubmissions", title: "Team Submissions", description: "See project feedback status by member and cycle." },
  { path: "/hodDashboard", title: "Delivery Overview", description: "See aggregate feedback and submission progress for your projects." },
  { path: "/configuration/global-designations", title: "Global Designation Config", description: "Manage approved designation types and USD hourly rates." },
  { path: "/tracking/timeline/:projectId", title: "Project Phase Timeline", description: "View project phase activity as a Gantt timeline." },
  { path: "/appraisalapprove", title: "CPO - Appraisal Approval", description: "Review, modify, approve or reject appraisals." },
  { path: "/approvedAppraisals", title: "Approved Appraisals", description: "View approved appraisal annexures." },
  { path: "/appraisalmanagement", title: "Appraisal Hub", description: "Manage approved appraisals, scheduling and history." },
  { path: "/scheduleAppraisal", title: "Schedule Appraisal Emails", description: "Schedule appraisal email delivery for generated letters." },
 
  {
    path: "/yourColleague",
    title: "Employee View Directory",
    description: "View and filter employee information.",
  },
  {
    path: "/yourColleague/details",
    title: "Employee Information",
    description: "View employee profile information.",
  },
  {
    path: "/team-availability",
    title: "Team Availability",
    description: "",
  },
  {
    path: "/training-sessions",
    title: "Training & Development",
    description: "",
  },
  {
    path: "/myProfile",
    title: "My Profile",
    description: "",
  },
  { path: "/assign-asset", title: "Assign Asset", description: "" },
  { path: "/createAssetRequest", title: "", description: "" },
  { path: "/approve-asset-IT", title: "Approve Asset IT", description: "" },
  { path: "/returned-asset", title: "Returned Asset", description: "" },
  {
    path: "/applyRegularization",
    title: "Apply Regularization",
    description: "",
  },
  {
    path: "/my-team-regularization",
    title: "My Team Regularization",
    description: "",
  },
  {
    path: "/approve-regularization",
    title: "Approve Regularization",
    description: "",
  },
  { path: "/createProject", title: "Create Project", description: "" },
  { path: "/createReimbursementRequest", title: "", description: "" },
  { path: "/create-employee", title: "Create Employee", description: "" },
  {
    path: "/iTApproval",
    title: "IT Setup",
    description: "Step 2 – IT reviews the form and generates the email ID.",
  },
  { path: "/leave-list", title: "Leave Update", description: "" },
  { path: "/employee-event", title: "Employees Event", description: "" },
  // { path: "/profile", title: "", description: "" },
  { path: "/evaluationView", title: "Evaluation", description: "" },
  {
    path: "/approveAssestRequest",
    title: "Approve Asset Request",
    description: "",
  },
  { path: "/employeeProfile", title: "", description: "" },
  { path: "/timeSheet", title: "Timesheets", description: "" },
  { path: "/timeSheetView", title: "Timesheet", description: "" },
  { path: "/biometric-employee-profile", title: "Timesheet", description: "" },
  {
    path: "/assetOverview/assetType/:id",
    title: "Asset Overview",
    description: "",
  },
  {
    path: "/emailDeletionRequest",
    title: "Add Email Deletion Request",
    description: "",
  },
  // {
  //   path: "/flowchart",
  //   title: "Organizational Chart",
  //   description: "",
  // },
  {
    path: "/timeAllocation",
    title: "Time Allocation",
    description: "",
  },
  {
    path: "/Reports",
    title: "Project Reports",
    description: "",
  },
  {
    path: "/pending-approvals",
    title: "Pending Approvals",
    description: "",
  },
  {
    path: "/probationReview",
    title: "Probation Review",
    description: "",
  },
  {
    path: "/extensionReport",
    title: "Extension Report",
    description: "",
  },
  {
    path: "/initiateresignation",
    title: "Initiate Offboarding Request",
    description: "",
  },
  {
    path: "/offboardl1",
    title: "Offboarding Review",
    description: "",
  },
  {
    path: "/offboardl1/:offboardingId",
    title: "Offboarding Review",
    description: "",
  },
  {
    path: "/offboardlIT/:offboardingId",
    title: "",
    description: "",
  },
  {
    path: "/offboardladmin/:offboardingId",
    title: "",
    description: "",
  },
  {
    path: "/offboardlpayroll/:offboardingId",
    title: "",
    description: "",
  },
  {
    path: "/offboardlhr/:offboardingId",
    title: "",
    description: "",
  },
  {
    path: "/offboardlrm/:offboardingId",
    title: "",
    description: "",
  },
 
];
